import File from './File';

const renderers: import('@wavevision/uploader').Renderers = { File };

export default renderers;
